<template>
  <div class="smaller-container-wrapper full-height no-progress-bar text-center py-5">
    <div class="copy-container">
      <img :src="require('@/assets/paper-check.svg')" alt="" />
      <h2>{{ $t('message.eCommerceV2.offer.thankYou.heading') }}</h2>
      <p class="mt-4 mb-5">{{ $t('message.eCommerceV2.offer.thankYou.msg', { dealership: getBusinessName }) }}</p>
    </div>
    <MobialisButton
      v-if="!hideAllCloseBtns"
      @click="clickBtn()"
      v-av-analytics-cta-interaction="{
        elementText: $t('message.eCommerceV2.offer.thankYou.btnText'),
        eventActionResult: 'exit',
      }"
      >{{ $t('message.eCommerceV2.offer.thankYou.btnText') }}
    </MobialisButton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { modalMethods } from '@/mixins';
import log from '@/services/log';
import helperFunctions from '@/utils/helperFunctions';

export default {
  name: 'OfferThankYou',
  mixins: [modalMethods],
  beforeRouteLeave: helperFunctions.ignoreRoutes(['offer-summary-form']),
  computed: {
    ...mapGetters('business', ['getBusinessName']),
  },
  methods: {
    async clickBtn() {
      await this.closeModal().catch(error =>
        log('Error completing lead after receiving close message from SDK.', error)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-container {
  max-width: 300px;
  margin: 0 auto;
}
@media (min-width: 576px) {
  .copy-container {
    max-width: 570px;
    p {
      max-width: 490px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .btn {
    width: auto !important;
  }
}
</style>
